var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"1e158baba6b1693817eec72d404042a3c2104290"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["docupet-app-login@docupet"]={id:"1e158baba6b1693817eec72d404042a3c2104290"};
      